import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarussel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCarussel"><Path d="M18.5 3.5H5.5V20.5H18.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 18.5H2.5V5.5H5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 5.5H21.5V18.5H18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCarussel;
